import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSpatialLayer } from '../../../../actions/spatialLayers';

const GMR_LANDING_ZONES_LAYER_KEY = 'gmr_landing_zones';

const useLandingZonesLayer = () => {
  const dispatch = useDispatch();

  const staticLayers = useSelector(state => state.spatialLayers.staticLayers);

  const layer = useMemo(() => {
    return (staticLayers || []).find(
      l => l?.key === GMR_LANDING_ZONES_LAYER_KEY,
    );
  }, [staticLayers]);

  const isPresent = Boolean(layer);
  const isEnabled = Boolean(layer?.isChecked);
  const spatialObjects = layer?.spatial_objects || [];

  const toggleLandingZoneLayer = isEnabled => {
    if (layer) {
      dispatch(
        toggleSpatialLayer(GMR_LANDING_ZONES_LAYER_KEY, false, isEnabled),
      );
    }
  };

  return {
    isPresent,
    isEnabled,
    spatialObjects,
    toggleLandingZoneLayer,
  };
};

export default useLandingZonesLayer;
